/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2024-01-09 10:47:41
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-05-13 17:42:57
 */
/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2024-01-08 21:01:09
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-01-09 10:32:47
 */
import type { Reducer, Effect } from 'umi'
import { getTeam, getTeamList, getTeamAll } from '@/services/system/team'
import { Types } from '@/constants/common'
import type { ITeamInfo } from '@/typings'
interface StateType {
  teamTree: any[]
  hiddenTeamTree: any[]
  teamTreeAll: any[]
  teamMemberTree: any[]
  currentOperate: number
}

interface ModelType {
  namespace: string
  state: StateType
  effects: {
    fetchGetTeam: Effect
    fetchGetTeamAll: Effect
    fetchGetTeamGroup: Effect
  }
  reducers: {
    saveTeamData: Reducer<StateType>
    saveTeamDataAll: Reducer<StateType>
    saveTeamGroupData: Reducer<StateType>
    updateCurrentOperate: Reducer<StateType>
  }
}

export const newTree = (data: ITeamInfo[]) => {
  const formatData = (list: ITeamInfo[]) => {
    return list
      .filter(item => item.members && item.members.length > 0)
      .map(item => {
        const node: any = {
          key: `${item.id}-${item.leader?.id}`,
          value: `${item.id}-${item.leader?.id}`,
          title: item.name,
          children: item.members?.map(m => ({
            key: m.account_id,
            value: m.account_id,
            title: m.name,
            job_code: m.job_code,
            parentGroup: m.team_name
          }))
        }
        if (item.children && item.children?.length > 0) {
          const subList = formatData(item.children)
          node.children = [...node.children, ...subList]
        }
        return node
      })
  }
  return formatData(data)
}
export const teamToTree = (data: ITeamInfo[]) => {
  const formatData = (list: ITeamInfo[]) => {
    return list
      .filter(item => item.members && item.members.length > 0)
      .map(item => {
        const node = {
          key: `team-${item.id}`,
          value: `team-${item.id}`,
          title: item.name,
          children: item.members?.map(m => ({
            value: `member-${item.id}-${m.account_id}`,
            title: m.name
            // job_code: m.job_code,
            // parentGroup: m.team_name
          }))
        }
        if (item.children && item.children?.length > 0) {
          const subList = formatData(item.children)
          node.children = [...(node?.children ?? []), ...subList]
        }
        return node
      })
  }
  return formatData(data)
}
const formatAllTree = (data: any) => {
  const formatData = list => {
    return list
      .filter(item => item.members && item.members.length > 0)
      .map(item => {
        const node: any = {
          key: `${item.id}-team`,
          value: `${item.id}-team`,
          title: item.name,
          children: item.members.map(m => ({
            key: m.id,
            value: m.id,
            title: m.name_en,
            role_codes: m.role_codes
          }))
        }
        if (item.sub_team.length > 0) {
          const subList = formatData(item.sub_team)
          node.children = [...node.children, ...subList]
        }
        return node
      })
  }
  return formatData(data)
}

const translateDataToTree = (data: any[], type = true) => {
  const treeData: any[] = []
  const translator = (parents: any[], newArr: any[]) => {
    parents.forEach(parent => {
      const obj: any = {
        key: `${parent.id}`,
        title: parent.name,
        type: Types.TEAM,
        children: []
      }
      newArr.push(obj)
      if (type && parent.members instanceof Array) {
        parent.members.forEach((employee: any) => {
          const employeeObj = {
            key: `${parent.id}-${employee.account_id}`,
            type: Types.USER,
            title: employee.name,
            data: {
              parentGroup: parent.name,
              // parentKey: `${parent.leader_id}-${parent.team_id}`,
              rank_name: employee.job_code,
              name_en: employee.name,
              uid: employee.account_id
            },
            children: []
          }
          obj.children.push(employeeObj)
        })
      }
      if (parent.children instanceof Array) {
        translator(parent.children, obj.children)
      }
    })
  }
  translator(data, treeData)

  return treeData
}

const TeamManagerModel: ModelType = {
  namespace: 'team',
  state: {
    currentOperate: 1,
    teamTree: [],
    hiddenTeamTree: [],
    teamTreeAll: [],
    teamMemberTree: []
  },

  effects: {
    // 获取团队列表
    *fetchGetTeamAll({ payload }, { call, put }) {
      const res = yield call(getTeamAll, { is_need_non_team: 1, is_hide_option: 1 })
      if (res.code === 0) {
        yield put({
          type: 'saveTeamDataAll',
          payload: res.data.list || []
        })
      }
    },
    // 获取团队列表
    *fetchGetTeam({ payload }, { call, put }) {
      const teamAll = yield call(getTeam, { page: 1, size: 999 })
      const hiddenOptionTeamAll = yield call(getTeam, { page: 1, size: 999, is_hide_option: 1 })
      if (teamAll.code === 0 && hiddenOptionTeamAll.code === 0) {
        yield put({
          type: 'saveTeamData',
          payload: {
            teamAll: teamAll.data.list || [],
            hiddenOptionTeamAll: hiddenOptionTeamAll.data.list || []
          }
        })
      }
    },
    // 获取团队列表
    *fetchGetTeamGroup({ payload }, { call, put }) {
      const res = yield call(getTeamList)
      if (res.code === 0) {
        yield put({
          type: 'saveTeamGroupData',
          payload: res.data.list || []
        })
      }
    }
  },

  reducers: {
    saveTeamDataAll(state, { payload }): any {
      return {
        ...state,
        teamTreeAll: formatAllTree(payload)
      }
    },
    saveTeamData(state, { payload }): any {
      return {
        ...state,
        teamTree: newTree(payload.teamAll),
        hiddenTeamTree: newTree(payload.hiddenOptionTeamAll)
      }
    },
    saveTeamGroupData(state, { payload }): any {
      return {
        ...state,
        teamMemberTree: translateDataToTree(payload)
      }
    },
    updateCurrentOperate(state, { payload }): any {
      return {
        ...state,
        currentOperate: payload
      }
    }
  }
}

export default TeamManagerModel
